<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import { afterUpdate } from 'svelte';
    import Modal from '../Modal.svelte';
    import Button from '../Button.svelte';
    import BasicFormLayout from '../Form/BasicFormLayout.svelte';
    import Errors from '../Errors.svelte';
    import yup from 'yup';
    import { submit } from '../../utils.js';
    import { validateForm } from '../Form/utils.js';
    import { sgettext } from '../../i18n.js';
    import {
        draftElementDetails,
        elementDetails,
        elementInstance
    } from '../Workspaces/workspacesStore.js';

    export let title = sgettext('$$PROMOTE_ELEMENT_CURRENT_VERSION$$');
    export let id = 'promoteToCurrentModal';
    export let eevId = 0;
    export let activityVersionId = 0;
    export let fioriGoverned = false;
    export let apmGoverned = false;
    export let onSuccess = async () => {};
    export let commentRequired = true;
    export let actionUrl = `${PATH_PREFIX}/sw/api/elements_database/elementelementversions/{eevId}/promote_to_current/`;

    let sending = false;
    let promote_to_current = true;

    let fields = initialFields();
    let formModel = defaultFormModel();
    let formErrors = [];
    let isValid = true;

    let schema = yup.object().shape({});

    $: if (commentRequired) {
        schema = yup.object().shape({
            comment: yup.string().required(sgettext('$$REQUIRED_FIELD$$')),
        });
    }

    function defaultFormModel() {
        var formModel = {
            comment: ''
        };
        if (fioriGoverned || apmGoverned) {
            formModel['request_number'] = '';
        }

        return formModel;
    }

    function initialFields() {
        let label = sgettext('$$DESCRIPTION_UPDATE$$');
        if (commentRequired) {
            label += '*';
        }
        else {
            label += ' (optional)';
        }

        var defaultFields = {
            comment: {
                label: sgettext(label),
                isValid: true,
                errors: null,
                type: 'text',
                multiline: true,
                rows: 4,
                ignoreFieldLevelValidation: true
            },
        };

        if (fioriGoverned || apmGoverned) {
            defaultFields['request_number'] = {
                label: apmGoverned ? sgettext('$$FIORI_REQUEST_NUMBER$$') : sgettext('$$FIORI_REQUEST_NUMBER_1$$'),
                isValid: true,
                errors: null,
                type: 'text',
                multiline: false,
            }
        }

        return defaultFields;
    }

    function onCancel() {
        formModel = defaultFormModel();
        jQuery(`#${id}`).modal('hide');
    }

    async function handleConfirm() {
        try {
            await validateForm(schema, formModel);
            sending = true;
            // If we are promoting an element from within the context of an activity version, pass to the backend this id
            var url = actionUrl.replace('{eevId}', eevId);
            if (activityVersionId != 0) {
                url = `${url}${activityVersionId}/`;
            }

            if($elementInstance && $elementInstance.id){
                formModel.elementInstanceId = $elementInstance.id;
            }

            const response = await submit(
                url,
                'POST',
                formModel
            );

            if (response.ok) {
                const json = await response.json();
                formModel = defaultFormModel();
                jQuery(`#${id}`).modal('hide');
                onSuccess(json);
            } else {
                let warnings = await response.json();
                let updatedElementDetails = {...$draftElementDetails};
                let translatedWarnings = [sgettext('$$UNABLE_PROMOTE_CURRENT$$')];
                for (let warning of warnings) {
                    translatedWarnings.push(warning);
                }
                updatedElementDetails.warnings = translatedWarnings;
                draftElementDetails.set(updatedElementDetails);
                window.scrollTo(0, 0);
            }
        } catch (err) {
            isValid = false;
            if (err.inner) {
                err.inner.forEach((er) => {
                    fields[er.path].isValid = false;
                    fields[er.path].errors = er.message;
                });
            }
        } finally {
            sending = false;
        }
    }

    afterUpdate(() => {
        fields = initialFields();
        formModel = defaultFormModel();
        formErrors = [];
        if (fioriGoverned) {
            if (commentRequired) {
                schema = yup.object().shape({
                    comment: yup.string().required(sgettext('$$REQUIRED_FIELD$$')),
                    request_number: yup.string().required(sgettext('$$REQUIRED_FIELD$$')),
                });
            }
            else {
                schema = yup.object().shape({
                    request_number: yup.string().required(sgettext('$$REQUIRED_FIELD$$')),
                });
            }
        } else {
            if (commentRequired) {
                schema = yup.object().shape({
                  comment: yup.string().required(sgettext('$$REQUIRED_FIELD$$')),
                });
            }
            else {
                schema = yup.object().shape({});
            }
        }
    });
</script>

<Modal {id} {title} {promote_to_current}>
    <div slot="header">
        <h4 class="modal-title">{title}
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" on:click={onCancel}>
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>
    </div>
    <div slot="body">
        <BasicFormLayout {id} {schema} {fields} {formModel} />
        {#if fioriGoverned && $elementDetails.is_fiori_governed }
            <p>{sgettext('$$CURRENT_VERSION_ELEMENT_USED_CURRENT$$')}</p>
        {/if}
        {#if formErrors && formErrors.length}
            <Errors errors={formErrors} />
        {/if}
    </div>

    <div slot="footer">
        <Button
            name={sgettext('$$CANCEL$$')}
            type="secondary"
            on:click={onCancel}/>
        <Button 
            name={sgettext('$$CONFIRM$$')} 
            on:click={handleConfirm} 
            {sending}/>
    </div>
</Modal>
